<template>
    <v-dialog v-model="showTemplate" max-width="1000px">
        <v-card>
            <v-card-title class="headline">문자 템플릿 신규 등록</v-card-title>
            <v-card-text>
                <v-col sm="6">
                    <v-text-field label="템플릿 관리용 제목입니다." v-model="smsTemplate.title" dense solo clearable flat outlined />
                </v-col>
                <v-textarea
                        name="input-7-1"
                        label=""
                        v-model="smsTemplate.content"
                        placeholder="문자 템플릿으로 사용할 내용을 등록하세요.
                        SMS 90bytes 메시지
                        LSM 2000bytes 메시지
                        "
                        value=""
                        hint="Hint text"
                        solo
                        flat
                        outlined
                />
                <v-btn class="vBtn vIconResize "  outlined @click="selectFullName">
                    <v-icon left>mdi mdi-clipboard-account</v-icon>
                    고객이름
                </v-btn>
            </v-card-text>
            <v-card-actions class="justify-center">
                <v-btn color="#1991eb" class="vIconResize" dark @click="saveTemplate()">
                    <v-icon left>mdi mdi-check</v-icon>
                    확인
                </v-btn>
                <v-btn color="#fafafa" class="vIconResize" @click.stop="showTemplate = false">
                    <v-icon left>mdi mdi-close</v-icon>
                    닫기
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import SmsApi from '@/api/SmsApi';

    export default {
        name: "TemplateDialog",
        props: ['visibleTamplate'],
        data: () => ({
            dialog: false,
            smsTemplate : {
                title : null,
                content : ''
            }
        }),
        computed: {
            showTemplate: {
                get() {
                    return this.visibleTamplate
                },
                set(value) {
                    if (!value) {
                        this.$emit('close')
                    }
                },
            },
        },
        methods: {
            selectFullName(){
                this.smsTemplate.content = this.smsTemplate.content+"{NAME}";
            },
            saveTemplate(){
                if(this.smsTemplate.title == null || this.smsTemplate.title == ""){
                    alert("제목을 입력하세요.");                    
                    return;
                }

               if(this.smsTemplate.content == null || this.smsTemplate.content == ""){
                    alert("내용을 입력하세요.");                    
                    return;
                }

                SmsApi.saveTemplate(this.smsTemplate).then(data => {
                    alert("등록되었습니다.");
                    if(data) {
                        this.showTemplate = false;
                        this.smsTemplate.title = "";
                        this.smsTemplate.content = "";                    
                    }                    
                });

                
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../assets/style/layout/variables';
    .headline {
        @include h2-title;
        margin: 0;
        background: #1867c0;
        color: #fff;
    }
</style>